import { render, staticRenderFns } from "./action-url-redirect.vue?vue&type=template&id=57817b8a&"
import script from "./action-url-redirect.vue?vue&type=script&lang=js&"
export * from "./action-url-redirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports